import { FC, ReactNode, useRef } from 'react';
import { Box, styled } from '@mui/material';

import { DataTree } from '@components/base';
import useGenericDataContext from '@hooks/useGenericDataContext';

const HighlightDiv = styled(Box)`
  display: flex;
  flex-direction: column;
  max-height: fill-available;
  overflow-x: auto;
  position: absolute;
  width: 100%;
  height: 100%;

  & * {
    flex-wrap: nowrap;
  }
`;

type TitleDataTreeProps = {
  data?: object;
  header?: ReactNode;
};

const TitleDataTree: FC<TitleDataTreeProps> = ({ data, header }) => {
  const { data: contextData = {} } = useGenericDataContext<object>();
  const ref = useRef(null);

  return (
    <HighlightDiv ref={ref}>
      <DataTree data={data ?? contextData} header={header} language='json' />
    </HighlightDiv>
  );
};

export default TitleDataTree;
